import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgFor, NgIf } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClipboardModule } from 'ngx-clipboard';
import { SoloDireccionesIpDirective } from '../../utilerias/directives/solo-direcciones-ip.directive';
import { SoloLetraEspacioNumeroAcentoDirective } from '../../utilerias/directives/solo-letra-espacio-numero-acento.directive';
import {
  PeticionesServidoresAplicaciones,
  ServidoresAplicacionesBase,
  VistaServidoresAplicaciones,
} from '../servidores-aplicaciones-comun/servidores-aplicaciones-base';

/** Consulta COS de servidores y aplicaciones; su plantilla también la usa la relación general (gestión). */
@Component({
  selector: 'app-consulta-servidores-aplicaciones',
  standalone: true,
  templateUrl: './consulta-servidores-aplicaciones.component.html',
  imports: [
    FormsModule,
    NgFor,
    NgIf,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    ClipboardModule,
    SoloDireccionesIpDirective,
    SoloLetraEspacioNumeroAcentoDirective,
  ],
})
export class ConsultaServidoresAplicacionesComponent extends ServidoresAplicacionesBase {
  readonly vista: VistaServidoresAplicaciones = {
    titulo: 'Consulta de Servidores y Aplicaciones COS',
    descripcion: 'Relación entre servidores, aplicaciones y usuarios COS.',
    tituloFiltros: 'Servidores COS',
    descripcionFiltros: 'Filtre primero el inventario COS y después navegue a usuarios y aplicaciones asociadas.',
    descripcionServidores: 'Seleccione un servidor para consultar sus usuarios y aplicaciones asociadas.',
    usuariosSinServidor: 'Seleccione un servidor para visualizar sus usuarios asociados.',
    maxLongitudSo: 100,
  };

  protected readonly peticiones: PeticionesServidoresAplicaciones = {
    totalServidores: (servidor) => this.fiseService.ConsultaNumServidoresCOS(servidor),
    paginaServidores: (consulta) => this.fiseService.consultarServidorPorIPPagCOS(consulta),
    totalUsuariosServidor: (usuario) => this.fiseService.contarUsuarioPorSERCOS(usuario),
    paginaUsuariosServidor: (consulta) => this.fiseService.obtenerUsuarioPorSERPagCOS(consulta),
    totalAplicaciones: (aplicacion) => this.fiseService.ConsultaNumAplicacionesCOS(aplicacion),
    paginaAplicaciones: (consulta) => this.fiseService.ObtenerAplicacionPorTipoCOS(consulta),
    totalUsuariosAplicacion: (usuario) => this.fiseService.contarUsuarioPorAPPCOS(usuario),
    paginaUsuariosAplicacion: (consulta) => this.fiseService.obtenerUsuarioPorAppPagCOS(consulta),
  };
}
